'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'HEADING_01',
	name: 'Heading',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*'],
	category: 'Text',
	props: [{
		name: 'text',
		inputType: 'hidden',
		default: 'Heading',
		required: true
	}, {
		name: 'editable',
		inputType: 'hidden',
		default: true
	}, {
		name: 'elementType',
		inputType: 'select',
		label: 'Size',
		default: 'h1',
		values: ['h1', 'h2', 'h3', 'h4', 'h5']
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass'])
};